export const endpoints = {
  findPatrimony: '/aggregation/patrimonyWithAccount/:patrimonyId',
  updatePatrimony: '/patrimony/update',
}
